import React, { useEffect, useState } from "react";
import { Row, Col, Button } from 'react-bootstrap';
import styles from "./PartialProductDetailsImgs.module.css"
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/rootReducer';
import { IColor } from '../../utilities/settings'
import ReactImageMagnify from 'react-image-magnify';

export interface IProductColors {
    itemColorId: number,
    colorId: number,
    unitPrice: number,
    colorCode: string,
    colorName: string
}
export interface IProductDetailsImgs {
    itemAssetId: number,
    assetURL: string,
    displayOrder: number,
    colorId: number
}
interface PropsType {
    productCard: IProductDetailsImgs[],
    colorCode: IColor,
    itemColor: IProductColors[],
    selectedColorId: number,
    IsOfferAvailable: boolean,
    IsNewArrival: boolean
}


export default function PartialProductDetailsImgs(props: PropsType) {
    const responsive = useSelector((state: RootState) => state.responsive);
    const [selectedImg, setSelectedImg] = useState<IProductDetailsImgs>(props.productCard[0]);
    const [isWeb, setIsWeb] = useState<boolean>(true);
    const [selectedColor, setSelectedColor] = useState<IProductColors>();
    const [hoverColorName, setHoverColorName] = useState("");

    useEffect(() => {
        if (responsive.isMobileLargeScreen || responsive.isMobileSmallScreen || responsive.isTabScreen) {
            setIsWeb(false)
        }
    }, [])

    useEffect(() => {
        if (props.selectedColorId) {
            selectColor(props.selectedColorId);
        }
    }, [props.selectedColorId])

    function selectedSlide(displayOrder: IProductDetailsImgs) {
        setSelectedImg(displayOrder)
    }

    function selectColor(itemColorId: number) {
        var item = props.itemColor.filter(a => a.itemColorId == itemColorId)[0];
        setSelectedColor(item);
        setHoverColorName(item.colorName)
        var img = props.productCard.filter((a: IProductDetailsImgs) => a.colorId == item.colorId)[0];
        if (img) {
            setSelectedImg(img);
        }
    }

    return (
        <React.Fragment>
            <div className={`${styles.mainContainer}`}>
                <Row>
                    <Col lg="12" md="12" xs="12" className={`${styles.fade} d-flex justify-content-center`}>
                        <div className={`${styles.brandSection} ${styles.fade}`}>
                            <Row className={`${styles.row}`}>
                                <div className={`${styles.mainImageContainer}`} style={{ backgroundColor: props.colorCode.primaryColor }}>

                                    <div className={`${styles.circle}`} style={{ color: props.colorCode.secondaryColor }}></div>
                                    {
                                        isWeb ?
                                            <ReactImageMagnify {...{
                                                smallImage: {
                                                    alt: "https://sajkoaonline.blob.core.windows.net/jkoa/itemimage/350/jkoa_default.png",
                                                    isFluidWidth: true,
                                                    src: selectedImg.assetURL,
                                                },
                                                largeImage: {
                                                    src: selectedImg.assetURL,
                                                    width: 1200,
                                                    height: 1200,
                                                },
                                                enlargedImageContainerDimensions: {
                                                    width: '120%',
                                                    height: '100%',
                                                },
                                                enlargedImageContainerStyle: { backgroundColor: "white", position: "absolute" },
                                                isHintEnabled: true,
                                                enlargedImagePosition: 'beside',
                                                shouldHideHintAfterFirstActivation: false
                                            }} />
                                            :
                                            <img className={`${styles.mainImage} ${styles.fade}`} src={selectedImg.assetURL}
                                                onError={(e: any) => { e.target.onerror = null; e.target.src = "https://sajkoaonline.blob.core.windows.net/jkoa/itemimage/350/jkoa_default.png" }} />
                                    }
                                    {props.IsOfferAvailable ?
                                        <div className={`jkoa-productDetail-specialOffer`}>Offer</div>
                                        : null
                                    }
                                    {props.IsNewArrival ?
                                        <div className={`jkoa-productDetail-newArrival`}>New Arrival</div>
                                        : null
                                    }
                                </div>
                            </Row>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <div className={`${styles.thumbnailContainer}`}>
                        {props.productCard.map((item: IProductDetailsImgs) => {
                            return (
                                <div key={item.itemAssetId} onClick={() => selectedSlide(item)} className={`${styles.thumbnail}`}
                                    style={{ border: "1px solid" + props.colorCode.secondaryColor, width: item.itemAssetId == selectedImg.itemAssetId ? "50px" : "35px" }}>
                                    <img className={`${styles.thumbnailImage}`} src={item.assetURL}
                                        onError={(e: any) => { e.target.onerror = null; e.target.src = "https://sajkoaonline.blob.core.windows.net/jkoa/itemimage/350/jkoa_default.png" }} />
                                </div>
                            );
                        })
                        }
                    </div>
                    <div hidden>
                        <span style={{ textAlign: "center", height: "17px" }}>{hoverColorName}</span>
                        <div className={`${styles.thumbnailContainer}`}>
                            {props.itemColor.map((item: IProductColors) => {
                                return (
                                    <div key={item.itemColorId} onClick={() => selectColor(item.itemColorId)}
                                        style={{ backgroundColor: item.colorCode, border: item.colorId == selectedColor?.colorId ? "2px solid" + props.colorCode.secondaryColor : "" }}
                                        className={`${styles.colorThumbnail} ${item.colorId == selectedColor?.colorId ? styles.selectedColor : null}`}
                                        onMouseEnter={() => setHoverColorName(item.colorName)} onMouseLeave={() => setHoverColorName(selectedColor?.colorName || "")}>
                                    </div>
                                );
                            })
                            }
                        </div>
                    </div>
                </Row>
            </div>
        </React.Fragment>
    )
}